import React from "react";
import style from "./styles.module.less";

// by 尊贵的 Tesla 车主 WangWang
import { ShieldSpinLoading } from "./loading";
interface IG2SpinProps {
  size?: number;
}

export const ShieldSpin = (props: IG2SpinProps) => {
  const size = props.size ? props.size : 50;

  return (
    <div
      style={{
        width: size,
        height: size,
      }}
    >
      <ShieldSpinLoading />
    </div>
  );
};

export const Spin = () => (
  <div className={style["g2-init-setting-loading"]}>
    <ShieldSpin size={100} />
  </div>
);
